/**
 * RiskAppetiteAdminPage (P66.2, #479).
 *
 * Mount point for /foundation/admin/risk-appetite-statements.
 * Thin wrapper that hands the `riskAppetiteAdapter` to the
 * shared `AdminListView`. Mirrors VendorAdminPage exactly.
 */
import { AdminListView } from "./AdminListView";
import { riskAppetiteAdapter } from "./riskAppetiteAdapter";

export function RiskAppetiteAdminPage() {
  return <AdminListView adapter={riskAppetiteAdapter} />;
}
